module.exports = __webpack_public_path__ + "static/img/airoad_combination03.d3353458.png";